import { Component } from "react";
import { Navigate } from "react-router-dom";
import Auth from "../utils/auth";
import NavigationContext from "../contexts/NavigationContext";

export class Authorize extends Component {
  static contextType = NavigationContext;

  isAuthorized() {
    const f = this.props.functionality;
    const access = Auth.get("access");
    if (!access) {
      return false;
    }
    let count = access.length;
    let isAccess = false;
    if (count > 0) {
      for (let i = 0; i < count; ++i) {
        if (access[i].functionality === f) {
          isAccess = true;
          break;
        }
      }
    }
    return isAccess;
  }

  render() {
    if (!this.isAuthorized()) {
      return <Navigate to="/error" />;
    }
    // This is a base class, so it shouldn't render anything itself.
    // Subclasses will override this and render their own content.
    return null;
  }
}
